import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/components/base/base-form.component';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TicketModel } from 'src/app/shared/models/domain/ticket.model';
import { BusinessContextService } from 'src/app/core/services/domain/business-context.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { AuthClientService } from 'src/app/core/services/auth/auth-client.service';

@Component({
  selector: 'app-ticket-form',
  templateUrl: './ticket-form.component.html',
  styleUrls: ['./ticket-form.component.scss']
})
export class TicketFormComponent extends BaseFormComponent<TicketModel> implements OnInit {
  constructor(private businessContextService: BusinessContextService, private authClientService: AuthClientService) {
    super();
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected getFormGroup(): UntypedFormGroup {
    return new UntypedFormGroup({
      firstName: new UntypedFormControl(this.authClientService.client?.firstName),
      lastName: new UntypedFormControl(this.authClientService.client?.lastName),
      business: new UntypedFormControl(this.businessContextService.currentBusiness?.name),
      email: new UntypedFormControl(this.authClientService.client?.email),
      subject: new UntypedFormControl(this.value?.subject),
      description: new UntypedFormControl(this.value?.description),
    })
  };
}
